export default __webpack_public_path__ + "static/media/kitchen3-afterA.deaa3152.jpg";